// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fa0527ae","72":"073f73f7","477":"4aa39512","627":"aef03c89","663":"d2be584f","667":"2318c11e","777":"395ac711","803":"8dbaf72d","820":"d57e13c1"}[chunkId] + ".chunk.js";
};